<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :UseScrollable="false"
        :HideModalFun="onHidden"
        :TitleWindow="$t('PatientPortalDashboard.Dropdown.PrintLetter')"
        :width="'70%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Download'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col md="12">
                <MdSelect
                    ref="option2"
                    v-bind:Label="$t('Shared.Template')"
                    v-bind:Options="letterTemplateList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:ModelArray="valueTemplate"
                    v-bind:Multiple="false"
                    v-bind:AllowEmpty="false"
                    :Input="changeDropDownOption"
                    v-bind:isRequired="true"
                    v-bind:isValid="this.isTemplateValid"
                />
            </b-col>
        </b-row>

        <b-row v-if="filters.length !== 0">
            <b-col md="3" lg="3" sm="12" v-for="(filter, index) in filters" :key="index">
                <MdDateTime
                    v-if="filter.controlType == 'ctDate'"
                    :Label="filter.caption"
                    :Model="filter.controlValue"
                    @input="filter.controlValue = $event"
                    :Id="`ctDate_${index}`"
                    :Type="'date'"
                    :isRequired="false"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="filter.isValid"
                    :ref="`ctDate_${index}`"
                >
                </MdDateTime>
                <!--
                <MdEdit
                    v-if="filter.controlType == 'ctDate'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'date'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isValid="filter.isValid"
                    :ref="`ctDate_${index}`"
                    v-bind:isRequired="true"
                    :OnPressEnter="onDatePressEnter"
                >
                </MdEdit>
                -->
                <MdEdit
                    v-if="filter.controlType == 'ctNumber'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'number'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >
                </MdEdit>
                <MdEdit
                    v-if="filter.controlType == 'ctEdit'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                    v-bind:Id="`ctDate_${index}`"
                >
                </MdEdit>
                <MdCheckBox
                    v-if="filter.controlType == 'ctCheckBox'"
                    v-bind:Label="filter.caption"
                    v-bind:CheckedValue="'Y'"
                    v-bind:UncheckedValue="'N'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctDate_${index}`"
                >
                </MdCheckBox>
                <MdSelect
                    v-if="filter.controlType == 'ctCombo'"
                    v-bind:Label="filter.caption"
                    v-bind:Options="filter.itemList"
                    v-bind:FieldDescription="'value'"
                    v-bind:FieldCode="'key'"
                    v-bind:Multiple="false"
                    v-bind:Model="filter.controlValue"
                    v-bind:UseParamsAux="true"
                    v-bind:AuxParam="filter"
                    :Input="changeDropDown"
                    v-bind:Name="`ctCombo_${index}`"
                    v-bind:Id="`ctCombo_${index}`"
                >
                </MdSelect>
                <MdEdit
                    v-if="filter.controlType == 'ctMemo'"
                    v-bind:Label="filter.caption"
                    v-bind:TypeProp="'text'"
                    v-model="filter.controlValue"
                    v-bind:Name="`ctMemo_${index}`"
                    v-bind:Id="`ctMemo_${index}`"
                >
                </MdEdit>
                <MdRadioGroup
                    v-if="filter.controlType == 'ctRadio'"
                    v-bind:Label="filter.caption"
                    v-model="filter.controlValue"
                    v-bind:Options="filter.itemList"
                >
                </MdRadioGroup>
            </b-col>
        </b-row>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
//import PatientPortalsService from '@/services/patientportals.service';
import NoteTemplatesService from '@/services/notetemplates.service';
import Utils from '@/common/utils';

export default {
    name: 'PatientPortalNotify',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCodeList: {
            type: Array,
            default: () => []
        },
        letterTemplateList: {
            Type: Array,
            default: () => []
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        }
    },
    data() {
        return {
            modalId: 'PatientPortalLetterModal',
            emitCloseEvent: false,
            valueTemplate: null,
            isTemplateValid: true,
            d_downloadContents: 0,
            filters: []
        };
    },
    methods: {
        changeDropDownOption(item) {
            this.d_downloadContents = 0;
            this.isTemplateValid = true;
            this.valueTemplate = item;

            if (item) {
                this.$nextTick(() => this.getLetterTemplateInfo(item.code));
            } else {
                this.filters = [];
            }
        },

        changeDropDown(e, filter) {
            filter.controlValue = e;
        },

        resetData() {
            this.valueTemplate = null;
            this.filters = [];
            this.d_downloadContents = 0;
            this.isTemplateValid = true;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.generateLetters();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate_required() {
            this.isTemplateValid = this.valueTemplate ? true : false;
            return this.isTemplateValid;
        },

        async generateLetters() {
            this.d_downloadContents = 0;
            let parameters = this.filters.map(x =>
                x.controlType == 'ctCombo'
                    ? x.controlValue != null && x.controlValue != undefined
                        ? x.controlValue.key
                        : ''
                    : x.controlValue
            );
            parameters.reverse();

            for (let index = 0; index < this.patientCodeList.length; index++) {
                const patientCode = this.patientCodeList[index];
                await this.generateLetterAsync(patientCode, parameters);
            }

            if (this.d_downloadContents === this.patientCodeList.length) {
                this.showMessage(
                    this.$t('Msg.Success'),
                    this.$t('Shared.SavedSuccessfully'),
                    'success'
                );
            } else {
                this.showMessage(
                    this.$t('Msg.Success'),
                    this.$t('PatientPortalDashboard.DownloadMessage', {
                        downloaded: this.d_downloadContents,
                        total: this.patientCodeList.length
                    }),
                    'warning'
                );
            }

            this.$emit('update:visible', false);
            this.resetData();
        },

        async generateLetterAsync(patientCode, parameters) {
            const data = {
                templateCode: this.valueTemplate.code,
                parameters: parameters,
                entityName: 'PatientCode',
                entityCode: patientCode,
                codeList: [patientCode],
                webQueryCode: true,
                kindOfDocument: 'html'
            };

            await NoteTemplatesService.generateLetter(data)
                .then(response => {
                    if (response.status == '200') {
                        const letterContents = response.data.letterContent;

                        if (!Utils.isNullOrEmptyString(letterContents)) {
                            this.downloadContent(patientCode, letterContents);
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        downloadContent(patientCode, content) {
            this.d_downloadContents++;
            const blob = new Blob([content], { type: 'application/html' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `lt_${patientCode}_${
                this.valueTemplate.code
            }_${Utils.generateUUID()}.html`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        },

        async getLetterTemplateInfo(code) {
            const data = {
                templateCode: code,
                KindOfDocument: 'html',
                webQueryCode: true,
                patientCode: this.patientCodeList[0]
            };
            await NoteTemplatesService.getLetterTemplateInfo(data)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.filters = [];
                        const customExportsItem = response.data;
                        customExportsItem.parameters.forEach(param => {
                            param.isValid = true;
                            if (param.controlType == 'ctCombo') {
                                param.controlValue = param.itemList.find(
                                    x => x.Key == param.controlValue
                                );
                            }
                            this.filters.push({ ...param });
                        });

                        this.filters.reverse();
                    } else {
                        this.filters = [];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
};
</script>
